import cn from "classnames";
import { Checkbox, Datetime, FileField } from "components/shared/form";
import { createRequestForUploadFile } from "helpers/form";
import React, { useState } from "react";
import { startNeuralNetworkTraining } from "sources/admin";

const StartNeuralNetworkTraining = (props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        const { file, ...rest } = data;
        const paramsRequest = data.file ? createRequestForUploadFile("file", data.file) : createRequestForUploadFile();
        for (const key in rest) {
            paramsRequest.body.append(key, data[key]);
        }
        startNeuralNetworkTraining(paramsRequest).then((res) => {
            setLoading(false);
            if (res) {
                props.back();
            }
        });
    };

    const renderDateField = (name, fieldProps = {}) => {
        const value = data[name];
        const onFieldChange = ({ value }) => setData({ ...data, [name]: value });
        return (
            <Datetime
                inputProps={{ name }}
                value={value}
                onChange={onFieldChange}
                {...fieldProps}
                labelWrapper="col-sm-6 col-form-label col-form-label-sm text-md-right text-sm-left"
                wrapper="col-sm-6"
                inPortal
            />
        );
    };

    const renderFileField = (name, fieldProps = {}) => {
        const value = data[name];
        const onFieldChange = ({ value }) => setData({ ...data, [name]: value });
        return (
            <FileField
                inputProps={{ name }}
                value={value}
                onChange={onFieldChange}
                {...fieldProps}
                labelWrapper="col-sm-6 col-form-label col-form-label-sm text-md-right text-sm-left"
                fieldWrapper="col-sm-6"
            />
        );
    };

    const renderCheckbox = (name, fieldProps = {}) => {
        const value = data[name];
        const onFieldChange = ({ value }) => setData({ ...data, [name]: value });
        return (
            <Checkbox
                inputProps={{ name }}
                value={value}
                onChange={onFieldChange}
                {...fieldProps}
                labelWrapper="col-sm-6 col-form-label col-form-label-sm text-md-right text-sm-left"
                fieldWrapper="col-sm-6"
            />
        );
    };

    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            {renderDateField("bidsStartDate", { label: "Дата начала поиска заявок" })}
            {renderDateField("stopsStartDate", { label: "Дата начала поиска оcтановок" })}
            {renderFileField("file", { label: "Файл для фильтрации точек" })}
            {renderCheckbox("collectBids", { label: "Сбор правильных данных" })}
            {renderCheckbox("collectStops", { label: "Сбор неправильных данных" })}
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
};

export default StartNeuralNetworkTraining;
